export const days = {
  '1': [
    { title: 'Dia 1', content: { state: 'ENABLED', text: '18/11' } },
    { title: 'Dia 2', content: { state: 'DISABLED', text: '19/11' } },
    { title: 'Dia 3', content: { state: 'DISABLED', text: '20/11' } },
    { title: 'Dia 4', content: { state: 'DISABLED', text: '21/11' } },
    { title: 'Dia 5', content: { state: 'DISABLED', text: '22/11' } },
    { title: 'Dia 6', content: { state: 'DISABLED', text: '23/11' } },
    { title: 'Dia 7', content: { state: 'DAY_7_DISABLED', text: '24/11 - 500 pontos Loop' } },
  ],
  '2': [
    { title: 'Dia 1', content: { state: 'CHECKED', text: '18/11' } },
    { title: 'Dia 2', content: { state: 'ENABLED', text: '19/11' } },
    { title: 'Dia 3', content: { state: 'DISABLED', text: '20/11' } },
    { title: 'Dia 4', content: { state: 'DISABLED', text: '21/11' } },
    { title: 'Dia 5', content: { state: 'DISABLED', text: '22/11' } },
    { title: 'Dia 6', content: { state: 'DISABLED', text: '23/11' } },
    { title: 'Dia 7', content: { state: 'DAY_7_DISABLED', text: '24/11 - 500 pontos Loop' } },
  ],
  '3': [
    { title: 'Dia 1', content: { state: 'CHECKED', text: '18/11' } },
    { title: 'Dia 2', content: { state: 'CHECKED', text: '19/11' } },
    { title: 'Dia 3', content: { state: 'ENABLED', text: '20/11' } },
    { title: 'Dia 4', content: { state: 'DISABLED', text: '21/11' } },
    { title: 'Dia 5', content: { state: 'DISABLED', text: '22/11' } },
    { title: 'Dia 6', content: { state: 'DISABLED', text: '23/11' } },
    { title: 'Dia 7', content: { state: 'DAY_7_DISABLED', text: '24/11 - 500 pontos Loop' } },
  ],
  '4': [
    { title: 'Dia 1', content: { state: 'CHECKED', text: '18/11' } },
    { title: 'Dia 2', content: { state: 'CHECKED', text: '19/11' } },
    { title: 'Dia 3', content: { state: 'CHECKED', text: '20/11' } },
    { title: 'Dia 4', content: { state: 'ENABLED', text: '21/11' } },
    { title: 'Dia 5', content: { state: 'DISABLED', text: '22/11' } },
    { title: 'Dia 6', content: { state: 'DISABLED', text: '23/11' } },
    { title: 'Dia 7', content: { state: 'DAY_7_DISABLED', text: '24/11 - 500 pontos Loop' } },
  ],
  '5': [
    { title: 'Dia 1', content: { state: 'CHECKED', text: '18/11' } },
    { title: 'Dia 2', content: { state: 'CHECKED', text: '19/11' } },
    { title: 'Dia 3', content: { state: 'CHECKED', text: '20/11' } },
    { title: 'Dia 4', content: { state: 'CHECKED', text: '21/11' } },
    { title: 'Dia 5', content: { state: 'ENABLED', text: '22/11' } },
    { title: 'Dia 6', content: { state: 'DISABLED', text: '23/11' } },
    { title: 'Dia 7', content: { state: 'DAY_7_DISABLED', text: '24/11 - 500 pontos Loop' } },
  ],
  '6': [
    { title: 'Dia 1', content: { state: 'CHECKED', text: '18/11' } },
    { title: 'Dia 2', content: { state: 'CHECKED', text: '19/11' } },
    { title: 'Dia 3', content: { state: 'CHECKED', text: '20/11' } },
    { title: 'Dia 4', content: { state: 'CHECKED', text: '21/11' } },
    { title: 'Dia 5', content: { state: 'CHECKED', text: '22/11' } },
    { title: 'Dia 6', content: { state: 'ENABLED', text: '23/11' } },
    { title: 'Dia 7', content: { state: 'DAY_7_DISABLED', text: '24/11 - 500 pontos Loop' } },
  ],
  '7': [
    { title: 'Dia 1', content: { state: 'CHECKED', text: '18/11' } },
    { title: 'Dia 2', content: { state: 'CHECKED', text: '19/11' } },
    { title: 'Dia 3', content: { state: 'CHECKED', text: '20/11' } },
    { title: 'Dia 4', content: { state: 'CHECKED', text: '21/11' } },
    { title: 'Dia 5', content: { state: 'CHECKED', text: '22/11' } },
    { title: 'Dia 6', content: { state: 'CHECKED', text: '23/11' } },
    { title: 'Dia 7', content: { state: 'DAY_7_ENABLED', text: '24/11 - 500 pontos Loop' } },
  ],
  '8': [
    { title: 'Dia 1', content: { state: 'CHECKED', text: '18/11' } },
    { title: 'Dia 2', content: { state: 'CHECKED', text: '19/11' } },
    { title: 'Dia 3', content: { state: 'CHECKED', text: '20/11' } },
    { title: 'Dia 4', content: { state: 'CHECKED', text: '21/11' } },
    { title: 'Dia 5', content: { state: 'CHECKED', text: '22/11' } },
    { title: 'Dia 6', content: { state: 'CHECKED', text: '23/11' } },
    { title: 'Dia 7', content: { state: 'DAY_7_CHECKED', text: '24/11 - 500 pontos Loop' } },
    { title: 'Dia 8', content: { state: 'DISABLED', text: '25/11' } },
  ],
}
